import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { type TQuoteApiCredTypes, tQuoteApi } from '../standards.js'

export type ddppCredType = TQuoteApiCredTypes
export const ddppDocumentTypes = [
  'delivery-photo',
  'invoice',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const ddpp: CarrierDef<ddppCredType> = {
  name: 'Dedicated Delivery Professionals',
  scac: 'ddpp',
  ...tQuoteApi,
  engineLayers: ['rating', 'pickup', 'tracking', 'documents'],
  documentTypes: ddppDocumentTypes,
}
